export default "__VITE_ASSET__e73YdQnR__"